import storage, { removeToken } from "@/utils/auth";
const getters = {
  token: (state) => state.sxt.token,
  phone: (state) => state.sxt.phone,
  member_phone_number: (state) => state.memberBenefits.member_phone_number,
  member_head_img: (state) => state.memberBenefits.member_head_img,
  member_token: (state) => state.memberBenefits.member_token,
  member_user_info: (state) => state.memberBenefits.member_user_info,
  carOwner_zhengxing_token: (state) => state.carOwner_zhengxing.token,
  carPhone_number: (state) => state.carOwner_zhengxing.carPhone_number,
  carOwner_zhengxing_user_info: (state) => state.carOwner_zhengxing.user_info,
};

export default getters;
